export const EASING_OPTIONS = [
  { value: "linear", label: "Linear" },
  { value: "power1.in", label: "Ease In" },
  { value: "power1.out", label: "Ease Out" },
  { value: "power1.inOut", label: "Ease In-Out" },
  { value: "power2.inOut", label: "Ease In-Out (Strong)" },
  { value: "bounce.out", label: "Bounce" },
  { value: "elastic.out", label: "Elastic" },
];

export default function EasingPicker({ value, onChange, onClose }) {
  return (
    <div
      className="absolute z-20 bg-[#0F0F0F] border border-[#145A43] rounded-md shadow-xl py-1 w-44"
      onMouseLeave={onClose}
    >
      {EASING_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          onClick={() => {
            onChange(opt.value);
            onClose();
          }}
          className={`w-full text-left px-3 py-1.5 text-xs transition-colors
            ${
              value === opt.value
                ? "bg-[#2F8F6F]/30 text-[#D7C7A1]"
                : "text-[#D7C7A1]/70 hover:bg-[#145A43]/40"
            }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
